<template>
  <div class="w-3/4 mx-auto bg-white mt-48 px-20 pt-10">
    <h1 class="uppercase font-extralight text-2xl py-10 text-center">{{ $t('review.title') }}</h1>
    <section class="flex flex-col text-left mt-20">
      <h2 class="uppercase text-xl border-b-2 border-orange-academy-300 w-1/2">
        {{ $t('review.aboutTeacher') }}
      </h2>
      <section>
        <div class="flex pt-6 items-center justify-between font-sans-serif">
          <label class="text-lg font-light">
            {{ $t('review.lessonTime') }}
          </label>
          <div class="flex tracking-wider space-x-1">
            <button @click="setLessonTimeVote(1)">
              <compact-disc :class="getSvgClass(lessonTimeVote, 1)" />
            </button>
            <button @click="setLessonTimeVote(2)">
              <compact-disc :class="getSvgClass(lessonTimeVote, 2)" />
            </button>
            <button @click="setLessonTimeVote(3)">
              <compact-disc :class="getSvgClass(lessonTimeVote, 3)" />
            </button>
            <button @click="setLessonTimeVote(4)">
              <compact-disc :class="getSvgClass(lessonTimeVote, 4)" />
            </button>
            <button @click="setLessonTimeVote(5)">
              <compact-disc :class="getSvgClass(lessonTimeVote, 5)" />
            </button>
          </div>
        </div>
        <div class="flex pt-6 items-center justify-between font-sans-serif">
          <label class="text-lg font-light">
            {{ $t('review.clarifications') }}
          </label>
          <div class="flex space-x-1">
            <button @click="setClarificationsVote(1)">
              <compact-disc :class="getSvgClass(clarificationsVote, 1)" />
            </button>
            <button @click="setClarificationsVote(2)">
              <compact-disc :class="getSvgClass(clarificationsVote, 2)" />
            </button>
            <button @click="setClarificationsVote(3)">
              <compact-disc :class="getSvgClass(clarificationsVote, 3)" />
            </button>
            <button @click="setClarificationsVote(4)">
              <compact-disc :class="getSvgClass(clarificationsVote, 4)" />
            </button>
            <button @click="setClarificationsVote(5)">
              <compact-disc :class="getSvgClass(clarificationsVote, 5)" />
            </button>
          </div>
        </div>
        <div class="flex pt-6 items-center justify-between font-sans-serif">
          <label class="text-lg font-light">
            {{ $t('review.interaction') }}
          </label>
          <div class="flex space-x-1">
            <button @click="setInteractionsVote(1)">
              <compact-disc :class="getSvgClass(interactionsVote, 1)"  />
            </button>
            <button @click="setInteractionsVote(2)">
              <compact-disc :class="getSvgClass(interactionsVote, 2)"  />
            </button>
            <button @click="setInteractionsVote(3)">
              <compact-disc :class="getSvgClass(interactionsVote, 3)"  />
            </button>
            <button @click="setInteractionsVote(4)">
              <compact-disc :class="getSvgClass(interactionsVote, 4)"  />
            </button>
            <button @click="setInteractionsVote(5)">
              <compact-disc :class="getSvgClass(interactionsVote, 5)"  />
            </button>
          </div>
        </div>
        <div class="flex pt-6 items-center justify-between font-sans-serif">
          <label class="text-lg font-light">
            {{ $t('review.explanation') }}
          </label>
          <div class="flex space-x-1">
            <button @click="setExplanationsVote(1)">
              <compact-disc :class="getSvgClass(explanationsVote, 1)"  />
            </button>
            <button @click="setExplanationsVote(2)">
              <compact-disc :class="getSvgClass(explanationsVote, 2)"  />
            </button>
            <button @click="setExplanationsVote(3)">
              <compact-disc :class="getSvgClass(explanationsVote, 3)"  />
            </button>
            <button @click="setExplanationsVote(4)">
              <compact-disc :class="getSvgClass(explanationsVote, 4)"  />
            </button>
            <button @click="setExplanationsVote(5)">
              <compact-disc :class="getSvgClass(explanationsVote, 5)"  />
            </button>
          </div>
        </div>
      </section>
      <h3 class="text-lg font-sans-serif w-1/2 pt-20 text-orange-academy-300 pl-2">
        {{ $t('review.comments') }}</h3>
      <textarea class="outline-none text-sm mt-2 border border-gray-200
      font-sans-serif p-2 shadow-lg" rows="5" placeholder="Write here.."
        v-model="teacherReview" />
    </section>
    <section class="flex flex-col text-left mt-32 mb-20">
      <h2 class="uppercase text-xl border-b-2 border-orange-academy-300 w-1/2">
        {{ $t('review.aboutPlatform') }}
      </h2>
      <section>
        <div class="flex pt-6 items-center justify-between font-sans-serif">
          <label class="text-lg font-light">
            {{ $t('review.platformAdapted') }}
          </label>
          <div class="flex space-x-1">
            <button @click="setPlatformVote(1)">
              <compact-disc :class="getSvgClass(platformVote, 1)"  />
            </button>
            <button @click="setPlatformVote(2)">
              <compact-disc :class="getSvgClass(platformVote, 2)"  />
            </button>
            <button @click="setPlatformVote(3)">
              <compact-disc :class="getSvgClass(platformVote, 3)"  />
            </button>
            <button @click="setPlatformVote(4)">
              <compact-disc :class="getSvgClass(platformVote, 4)"  />
            </button>
            <button @click="setPlatformVote(5)">
              <compact-disc :class="getSvgClass(platformVote, 5)"  />
            </button>
          </div>
        </div>
        <div class="flex pt-6 items-center justify-between font-sans-serif">
          <label class="text-lg font-light">
            {{ $t('review.audioVideo') }}
          </label>
          <div class="flex space-x-1">
            <button @click="setAudioVideoVote(1)">
              <compact-disc :class="getSvgClass(videoAudioVote, 1)" />
            </button>
            <button @click="setAudioVideoVote(2)">
              <compact-disc :class="getSvgClass(videoAudioVote, 2)" />
            </button>
            <button @click="setAudioVideoVote(3)">
              <compact-disc :class="getSvgClass(videoAudioVote, 3)" />
            </button>
            <button @click="setAudioVideoVote(4)">
              <compact-disc :class="getSvgClass(videoAudioVote, 4)" />
            </button>
            <button @click="setAudioVideoVote(5)">
              <compact-disc :class="getSvgClass(videoAudioVote, 5)" />
            </button>
          </div>
        </div>
      </section>
      <h3 class="text-lg font-sans-serif w-1/2 pt-20 text-orange-academy-300 pl-2">
        {{ $t('review.comments') }}</h3>
      <textarea class="outline-none text-sm mt-2 border border-gray-200
        font-sans-serif p-2 shadow-lg" rows="5" placeholder="Write here.."
        v-model="platformReview" />
    </section>
    <div class="flex justify-center">
      <button class="rounded shadow-md border border-orange-academy-300 bg-orange-academy-300
        text-white text-lg px-5 py-2 mb-32
        uppercase font-sans-serif transform hover:scale-110 duration-300"
        @click="saveReview">
          {{ $t('review.save') }}
      </button>
    </div>

    <v-dialog name="savedReview" @closed="$router.push('/dashboard')"  />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import CompactDisc from '../components/CompactDisc.vue';

export default {
  data() {
    return {
      lesson: {},

      lessonTimeVote: 0,
      clarificationsVote: 0,
      interactionsVote: 0,
      explanationsVote: 0,

      platformVote: 0,
      videoAudioVote: 0,

      teacherAvg: null,
      platformAvg: null,
      teacherReview: '',
      platformReview: '',
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  components: {
    CompactDisc,
  },

  created() {
    this.getLesson();
  },

  methods: {
    getLesson() {
      axios.get(`/api/lessons/${this.$route.query.booking}`).then(({ data }) => {
        this.lesson = data;
      });
    },

    getSvgClass(variable, vote) {
      if (variable >= vote) return 'text-yellow-600';
      return 'hover:text-yellow-600';
    },

    setLessonTimeVote(vote) {
      this.lessonTimeVote = vote;
    },

    setClarificationsVote(vote) {
      this.clarificationsVote = vote;
    },

    setInteractionsVote(vote) {
      this.interactionsVote = vote;
    },

    setExplanationsVote(vote) {
      this.explanationsVote = vote;
    },

    setPlatformVote(vote) {
      this.platformVote = vote;
    },

    setAudioVideoVote(vote) {
      this.videoAudioVote = vote;
    },

    setTeacherAvg() {
      const sum = this.lessonTimeVote + this.clarificationsVote
        + this.interactionsVote + this.explanationsVote;

      this.teacherAvg = sum / 4;
    },

    setPlatformAvg() {
      const sum = this.platformVote + this.videoAudioVote;

      this.platformAvg = sum / 2;
    },

    saveReview() {
      if (this.check()) {
        this.setTeacherAvg();
        this.setPlatformAvg();

        const review = {
          student_id: this.user.student.id,
          teacher_id: this.lesson.teacher_id,
          lesson_id: this.lesson.lesson_id,
          teacher_avg: this.teacherAvg,
          teacher_review: this.teacherReview,
          platform_avg: this.platformAvg,
          platform_review: this.platformReview,
        };

        axios.post('/api/reviews', review).then(() => {
          this.createNotification('success', this.$t('review.savedReview'));
          this.$router.push('/student-dashboard');
        }).catch((error) => {
          console.log(error);
        });
      }
    },

    check() {
      let ok = true;
      if (this.lessonTimeVote === 0 || this.clarificationsVote === 0
      || this.interactionsVote === 0 || this.explanationsVote === 0) {
        ok = false;
        this.createNotification('error', this.$t('notifications.voteTeacher'));
      }

      if (this.platformVote === 0 || this.videoAudioVote === 0) {
        ok = false;
        this.createNotification('error', this.$t('notifications.votePlatform'));
      }

      return ok;
    },
  },
};
</script>
